import * as React from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app'
// import { enableMocking } from './testing/mocks';

const root = document.getElementById('root')
if (!root) throw new Error('No root element found')

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// enableMocking().then(() => {
//   createRoot(root).render(
//     <React.StrictMode>
//       <App />
//     </React.StrictMode>,
//   );
// });
